import { reatomAsync, withAbort, withDataAtom } from "@reatom/async";
import { CalculatePriceRequestDto } from "definitions/poizon-bff";
import { API } from "src/api";
import { withDebounce, withIsLoadingAtom } from "src/common/pipes";

export const getSubscribePriceRequest = reatomAsync(
  async (ctx, data: CalculatePriceRequestDto) => {
    return await API.subscribeApi
      .subscribeControllerCalculatePrice(data, {
        signal: ctx.controller.signal,
      })
      .then((res) => res.data);
  },
  "getSubscribePriceRequest",
).pipe(withDataAtom(null), withAbort(), withIsLoadingAtom());

export const getSubscribePriceRequestWithDebouncing =
  getSubscribePriceRequest.pipe(withDebounce(300));
